import { IExchangeState } from 'types/exchange';

export default function mergeShopData(state: IExchangeState, payload: { id: number, items: any[] }) {
  const { id, items } = payload;
  return {
    ...state.shops,
    [id]: { ...state.shops[id], items },
  };
}